export default __webpack_public_path__ + "static/media/Inspection.7c940887.svg";